module.exports = __webpack_public_path__ + "img/video-connectivy-1.d2f12342.png";